import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { PIconModule } from '@panaya/ui/p-icon';
import { injectWidgetConfigProp } from '@panaya/ai-chat/utils';
import { WidgetResourceUrlPipe } from '@panaya/ai-chat/ui';

/**
 * A local empty / error state: the legacy `empty-state` component is not publishable. The illustration is the host's
 * `emptyStateImageURL`.
 */
@Component({
    standalone: true,
    selector: 'p-ai-chat-canvas-empty-state',
    imports: [NgIf, PIconModule, WidgetResourceUrlPipe],
    templateUrl: './canvas-empty-state.component.html',
    styleUrls: ['./canvas-empty-state.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CanvasEmptyStateComponent {
    @Input() kind: 'info' | 'error' = 'info';
    @Input() title = '';
    @Input() message: string | null = null;
    protected readonly imageUrl = injectWidgetConfigProp('emptyStateImageURL');
}
